<template>
    <v-app :class="{'mobile-app': capRunning}">
        <loading :loading="!appLoadedOnce || loading"></loading>

        <template v-if="appLoadedOnce">

            <force-update />

            <app-menu v-if="isAuthed" v-model="appMenu"/>
            <guest-menu v-else v-model="guestMenu"/>

            <navbar v-if="isAuthed" :height="navbarHeight" @menu="showMenu"/>

            <!-- confirm email msg -->
            <div v-if="innerApp && !confirmed" class="fixed-top-bar d-flex align-center justify-space-between justify-md-center pa-0 white--text orange" :style="`top: ${navbarHeight}px`">
                <div class="px-3">Account not confirmed</div>
                <v-btn text large tile color="grey darken-3" class="light--text" @click.stop="openConfirmPage">
                    <span class="white--text">confirm</span>
                </v-btn>
            </div>

            <v-main v-if="appLoadedOnce" class="main-container" :class="{'pc': pcOnly, 'is--app': capRunning, 'white': $route.meta.whiteBackground}" :style="'padding-top: ' + navbarHeight">
                <transition :name="transitionName" mode="out-in">
                    <router-view>
                        <!-- to add footer, just put <slot name="footer"> in view and set route meta.footer to true then footer will be auto inserted & transition will be auto changed   -->
                        <!-- <e-footer slot="footer" :fixed="!$route.meta.footer.notFixed" v-if="$route.meta.footer && $route.meta.footer.show" :light="!$route.meta.footer.dark" /> -->
                    </router-view>
                </transition>
            </v-main>

            <bottom-navigation v-if="capRunning" />


            <transition name="scale-transition" appear trans>
                <v-btn v-if="$route.name !== 'help' && appData.whatsapp_url && appData.show_whatsapp_fab_button" as="a" dark target="_blank" :large="pcOnly" :href="appData.whatsapp_url" fab fixed depressed bottom right color="green" :style="`bottom: ${pcOnly ? 40 : iosSafeArea ? 105 : 70}px; right: ${56+(pcOnly ? 40 : 20)}px;`">
                    <v-icon :size="pcOnly ? 34 : 30">mdi-whatsapp</v-icon>
                </v-btn>
            </transition>

            <transition name="scale-transition" appear trans>
                <v-btn v-if="$route.name !== 'help'" :large="pcOnly" fab fixed depressed bottom right :color="isAuthed ? 'primary' : 'secondary'" :class="{'primary--text': !isAuthed}" :style="`bottom: ${pcOnly ? 40 : (iosSafeArea ? 105 : 70)}px; right: ${pcOnly ? 40 : 20}px;`" :to="{name: 'help'}">
                    <v-icon :size="pcOnly ? 34 : 30">mdi-help</v-icon>
                </v-btn>
            </transition>

            <announcement-dialog v-if="appData && innerApp && !announcementDismissed && !walletDisabled && appData.general_announcement" :value="appData && appData.general_announcement" />

            <!-- footer -->
            <!-- <e-footer light v-if="appLoadedOnce && showFooter" /> -->
            <app-msg :navbar-height="navbarHeight" />
        </template>

    </v-app>
</template>

<script>
import moment from 'moment-timezone'

import AppMsg from "./components/default/app-msg";
import Loading from "./components/default/loading";
import AnnouncementDialog from "./components/default/dialogs/announcement-dialog";

import GlobalComputed from './helpers/global-computed'
import GlobalMethods from './helpers/global-methods'
import legacyTimezones from './helpers/legacy-timezones'
import Colors from './helpers/colors'

import Navbar from './components/main/navbar/navbar'
import BottomNavigation from './components/main/bottom-navigation.vue'
import AppMenu from './components/main/app-menu'
import GuestMenu from './components/main/guest-menu'
// import EFooter from './components/main/e-footer'

import Echo from "laravel-echo"

import AppAPI from '@/app-api'
import ForceUpdate from "./components/default/force-update";

export default {
    name: "App",

    components: {
        AnnouncementDialog,
        ForceUpdate,
        Loading,
        AppMsg,
        Navbar,
        AppMenu,
        BottomNavigation,
        GuestMenu,
    },

    data: () => ({
        guestMenu: false,
        appMenu: false,
        transitionName: 'fade-up',
    }),
    computed: {
        navbarHeight(){
            return this.pcOnly ? 70 : 65;
        },
        showFooter(){
            return this.$route.meta.footer;
        },
        walletDisabled(){
            return !this.appData.enable_app_w;
        },
        innerApp(){
            return this.isAuthed && this.$route.name !== 'confirm';
        },
        confirmed(){
            if (!this.user || !this.appData.email_verification){
                return true;
            }
            return !!this.user.email_verified_at;
        },
        loading(){
            return this.$store.state.globalModule.loading;
        },
        announcementDismissed(){
            return this.$store.state.globalModule.announcementDismissed;
        },
        ...GlobalComputed
    },
    watch: {
        $route(to, from){
            // force email verification
            this.forceEmailConfirm(to.name);
            this.teacherStudentMiddleware(to);

            if (to.name === 'login'){
                if (from.name ==='register'){
                    this.transitionName = 'fast-fade';
                }
            }else if (to.name === 'register'){
                if (from.name === 'login'){
                    this.transitionName = 'fast-fade';
                }
            }else{
                this.transitionName = this.isAuthed ? 'fast-fade' : 'fade-up';
            }

            if (to.meta.footer){
                // to fix footer bug with transition
                this.transitionName = 'fade';
            }
        },
        isAuthed(authed){
            if (!authed){
                this.$router.push({name: 'login'});
            }else{
                // user logged in or registered
                this.saveTimezone();
                this.connectToWebsockets();
            }
        },
    },
    methods: {
        showMenu(){
            if (this.isAuthed){
                this.appMenu = !this.appMenu;
            }else{
                this.guestMenu = !this.guestMenu;
            }
        },
        logout(){
            this.$store.dispatch('logout');
        },
        openConfirmPage(){
            this.$router.push({name: 'confirm'});
        },
        getUserCountry(){
            // get only in production
            if (process.env.NODE_ENV === "production"){
                window.axios.get('https://ip2c.org/s').then(response=>{
                    if (response && response.data){
                        this.$store.commit('SET_USER_COUNTRY', response.data.split(';')[1]);
                    }
                });
            }
        },
        teacherStudentMiddleware(route){
            const isTeacher = this.isTeacher;
            if (route.meta.studentOnly && isTeacher){
                this.$router.push({name: 'not-found'});
            }else if (route.meta.teacherOnly && !isTeacher){
                this.$router.push({name: 'not-found'});
            }
        },
        forceEmailConfirm(route=null){
            if (!route){
                route = this.$route.name;
            }
            const force = process.env.VUE_APP_FORCE_CONFIRMATION;
            if (force){
                if (!this.confirmed){
                    if (route !== 'confirm'){
                        this.openConfirmPage();
                    }
                }
            }
        },
        saveTimezone(){
            let timezone = moment.tz.guess();
            timezone = legacyTimezones[timezone] ?? timezone;

            if (!this.user.timezone || timezone !== this.user.timezone){
                if (timezone){
                    this.$store.dispatch('fastPutAction', {url: `/tz`, data: {timezone}});
                }
            }
        },
        connectToWebsockets(){
            let WsConfig = this.appData.WsConfig;
            if (WsConfig){
                const token = window.localStorage.getItem('tK');
                WsConfig.auth = {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                };
                window.Echo = new Echo(WsConfig);
            }
        },
        importPaypalSdkScript(){
            const clientId = this.appData.pp_client;
            if (clientId){
                let script = document.createElement('script')
                script.setAttribute('src', `https://www.paypal.com/sdk/js?client-id=${clientId}&locale=en_US`)
                document.head.appendChild(script)
            }
        },
        afterAuthActions(){
            this.connectToWebsockets();
            this.forceEmailConfirm();
            this.teacherStudentMiddleware(this.$route);
            // this.saveTimezone();
        },
        initApp(){
            const self = this;
            this.importPaypalSdkScript();
            // window.console.log('App Init');
            // check token is valid or not
            this.$store.dispatch('checkAuth').then(response=>{
                // then set loaded to true
                window.setTimeout(()=>{
                    self.$store.dispatch('appLoaded'); // set app loaded status
                }, 100);

                self.afterAuthActions();

            }).catch(error=>{
                this.getUserCountry();
                const unauthenticated = this.checkErrorStatus(error);
                if (unauthenticated || !error){
                    if (unauthenticated){
                        this.$router.push({name: 'login'});
                    }
                    window.setTimeout(()=>{
                        self.$store.dispatch('appLoaded'); // set app loaded status
                    }, 250);
                }else{
                    this.showMsg('Error occurred during loading your info, please reload the app.', 'error', false, false, 100000);
                }
            });

        },

        checkErrorStatus(error){
            if (error && error.response && error.response.status){
                // if unauthorized (maybe logout or token changed)
                if (error.response.status === 401){
                    this.logout();
                    return true;
                }
            }
            return false;
        },
        ...GlobalMethods,
    },
    created(){
        if (this.capRunning){
            AppAPI.init(this);
            AppAPI.changeStatusbar(false, true);
        }
    },
    mounted(){
        // first load app global data / settings (admin app data)
        this.$store.dispatch('loadAppData').then(()=>{

            // if nor running, init app now
            // we are on browser/web app!
            this.initApp();

        }).catch(()=>{
            this.showMsg('(1) Error occurred during loading your data');
        })
    }
};
</script>

<style lang="scss">
@import 'scss/main';
.main-container{
}
</style>